<template>
  <div class="jr-mx-15 jr-text-left">
    <p class="jr-text-sm jr-font-medium">選択した道路に来訪した時点を一律で0hとしたときの、前後1時間の行動をヒートマップで表示しています。</p>
    <p class="jr-text-s jr-pt-6.252">
      <span class="jr-mr-2.5">※</span>
      <span>「対象道路近辺のログを非表示」をチェックすると、道路への流出入がより強調されます。</span>
    </p>
  </div>
</template>
